import React from "react";
import ban from "../../../assets/icons/ban.svg";
import { useTranslation } from "react-i18next";
import { navigatedToPreviousStep } from "../../../redux/slice/apartmentRental/apartmentRentalSlice";
import { useDispatch } from "react-redux";
import { Button } from "components/ui/button";

/**
 * The honest empty result: the search ran and nothing matches.
 *
 * Tenant primary is the only accent colour (CLAUDE.md). This screen used to
 * carry kolula's own turquoise — `#C9F7F9` behind the icon, `#00C9C9` on the
 * button — plus raw grays, so on a red-primary tenant it was the one screen in
 * a foreign brand (#2764 side finding, present since the initial import). The
 * accent now comes from the tenant's theme tokens and the text from the
 * foreground scale.
 */
const NoResult = () => {
  const dispatch = useDispatch();
  const handleBackClick = () => {
    dispatch(navigatedToPreviousStep());
  };
  const { t } = useTranslation();
  return (
    <div className="flex flex-col items-center justify-center p-8 text-center">
      <div className="mb-4 rounded-full bg-primary/10 p-4">
        {/* Decorative: the heading below says what happened. The alt text
            was a hardcoded English sentence read out on German pages. */}
        <img src={ban} alt="" aria-hidden="true" width="48" height="48" />
      </div>
      <h3 className="mb-2 text-lg font-semibold text-foreground">
        {t("apartment.no_apartment.title")}
      </h3>
      <p className="mb-6 text-sm text-foreground/70">
        {t("apartment.no_apartment.sub_title")}
      </p>
      <Button variant="outline" onClick={handleBackClick}>
        {t("apartment.no_apartment.button_title")}
      </Button>
    </div>
  );
};

export default NoResult;
